import React from 'react';
import Navbar from '../components/Navbar';
import { useNavigate, useLocation } from 'react-router-dom';
import { Check, Star, Zap, ShieldCheck } from 'lucide-react';
import './Pricing.css';

function Pricing() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isFromChat = searchParams.get('source') === 'chat';
    const highlightPlan = searchParams.get('plan');

    React.useEffect(() => {
        if (highlightPlan === 'basic') {
            const basicCard = document.querySelector('.pricing-card:not(.popular)');
            if (basicCard) {
                basicCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                basicCard.classList.add('highlight-pulse');
            }
        }
    }, [highlightPlan]);

    const plans = [
        {
            name: 'Plan Mensual',
            price: '80 $',
            period: '/mes',
            description: 'Ideal para conversaciones espirituales mensuales',
            features: [
                '30 chats divinos al mes',
                'Guardar historial de conversaciones',
                'Acceso a los 700+ versos',
                'Guía personal',
                'Disponible 24/7'
            ],
            buttonText: 'Empezar ahora',
            isPopular: false,
            color: 'var(--blue-glow)',
            plan_id: 'monthly_30'
        },
        {
            name: 'Plan Premium',
            price: '250 $',
            period: '/año',
            description: 'Plan anual para quienes buscan la mejor experiencia',
            features: [
                '360 conversaciones al año',
                'Todas las funciones del plan mensual',
                'Generación de voz prioritaria',
                'Guardar historial de conversaciones',
                'Soporte prioritario'
            ],
            buttonText: 'La opción más popular',
            isPopular: true,
            color: 'var(--accent-glow)',
            plan_id: 'premium_30_yearly'
        }
    ];

    return (
        <div className="pricing-page">
            <Navbar />

            {/* Floating Coupon Notification */}
            <div className="coupon-floating-banner">
                <div className="coupon-content">
                    <div className="coupon-icon">🎁</div>
                    <div className="coupon-text-wrapper">
                        <span className="coupon-label">OFERTA ESPECIAL</span>
                        <p>Usa <strong>KRISHNA5</strong> para el Plan Básico por solo <strong>5 $</strong></p>
                    </div>
                </div>
                <div className="coupon-sparkles"></div>
            </div>

            <div className="pricing-container container">
                <header className="pricing-header">
                    <div className="pricing-badge">
                        <Zap size={14} />
                        <span>TARIFAS</span>
                    </div>
                    <h1 className="pricing-title">
                        Elige el <span className="gradient-text-animated">camino de tu alma</span>
                    </h1>
                    <p className="pricing-subtitle">
                        Comienza a invertir en tu paz interior y crecimiento espiritual <br />
                        con el plan adecuado para ti.
                    </p>

                    {isFromChat && (
                        <div className="chat-upgrade-notice">
                            <div className="notice-icon">✨</div>
                            <div className="notice-text">
                                <strong>Límite agotado:</strong> 
                                Por favor, elige un plan para continuar el chat.
                            </div>
                        </div>
                    )}
                </header>

                <div className="pricing-grid">
                    {plans.map((plan, index) => (
                        <div
                            key={index}
                            className={`pricing-card ${plan.isPopular ? 'popular' : ''}`}
                        >
                            {plan.isPopular && <div className="popular-badge">Popular</div>}

                            <div className="plan-name">{plan.name}</div>

                            <div className="plan-price">
                                <span className="currency">{plan.price}</span>
                                <span className="period">{plan.period}</span>
                            </div>

                            <p className="plan-description">{plan.description}</p>

                            <div className="plan-features">
                                {plan.features.map((feature, fIndex) => (
                                    <div key={fIndex} className="feature-item">
                                        <div className="check-icon">
                                            <Check size={16} />
                                        </div>
                                        <span>{feature}</span>
                                    </div>
                                ))}
                            </div>

                            <button
                                className={`plan-button ${plan.isPopular ? 'btn-premium-primary' : 'btn-premium-secondary'}`}
                                onClick={() => navigate('/checkout', { state: { plan } })}
                            >
                                {plan.buttonText}
                            </button>
                        </div>
                    ))}
                </div>

                <div className="pricing-trust">
                    <div className="trust-item">
                        <ShieldCheck size={24} />
                        <span>Pagos seguros</span>
                    </div>
                    <div className="trust-item">
                        <Star size={24} />
                        <span>100% satisfacción</span>
                    </div>
                    <div className="trust-item">
                        <Zap size={24} />
                        <span>Acceso instantáneo</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pricing;
